<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = withDefaults(
    defineProps<{
        currentPosition?: boolean;
        data?: {
            name: string;
            slug: string;
        };
    }>(),
    {
        currentPosition: false,
        data: undefined
    }
);
const route = useRoute();

const titleCase = (str: string) => {
    return str.replace(
        /\b\w/g,
        char => char.toUpperCase()
    );
};

const breadcrumbs = computed(() => {
    const { fullPath } = route;

    const pathWithoutQuery = fullPath.split('?');
    const params = pathWithoutQuery[0]
        ? pathWithoutQuery[0].startsWith('/')
            ? pathWithoutQuery[0].substring(1).split('/')
            : pathWithoutQuery[0].split('/')
        : [];

    const breadcrumbsArray: {
        label: string;
        path: string;
        active: boolean;
    }[] = [
        {
            label: 'Home',
            path: '/',
            active: fullPath === '/'
        }
    ];

    let pathAccumulator = '';

    params.forEach((param, index) => {
        pathAccumulator += `/${param}`;

        const label = props.data && props.data.slug && props.data.slug === param
            ? props.data.name
            : titleCase(param.replace(
                    /-/g,
                    ' '
                ));

        breadcrumbsArray.push({
            label: label,
            path: pathAccumulator,
            active: index === params.length - 1
        });
    });

    return props.currentPosition ? breadcrumbsArray.slice(0, -1) : breadcrumbsArray;
});

</script>

<template>
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb display-flex align-items-center gap-4"
        itemscope
        itemtype="http://schema.org/BreadcrumbList"
    >
      <li v-for="(crumb, index) in breadcrumbs"
          :key="index"
          class="display-flex align-items-center gap-4"
          itemprop="itemListElement"
          itemscope
          itemtype="http://schema.org/ListItem"
      >
        <NuxtLink v-if="!crumb.active"
                  :to="crumb.path"
                  class="compact-500-accent"
                  itemprop="item"
        >
          <span class="compact-500-accent"
                itemprop="name"
          >{{ crumb.label }}</span>
        </NuxtLink>
        <span v-else
              :class="['compact-500-accent', {'breadcrumb-active': crumb.active}]"
              itemprop="name"
        >{{ crumb.label }}</span>
        <meta itemprop="position"
              :content="`${index + 1}`"
        >
        <IconMain v-if="index < breadcrumbs.length - 1"
                  icon="arrow-r-l"
                  :size="24"
                  class="breadcrumb-arrow"
        />
      </li>
    </ol>
  </nav>
</template>

<style lang="scss">
.breadcrumb {
  padding: $spacing-400 0;
  list-style: none;
}

.breadcrumb-active {
  //color: var(--bg-brand-aviation-primary);
}

.breadcrumb-arrow {
  color: var(--content-secondary);
}
</style>
